import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { LogError } from '@memberjunction/core';

async function initAndBootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(ref => {
      //LogStatus('Bootstrap success: ' + ref);
    })
    .catch(err => LogError('Bootstrap error:', undefined, err));
}

initAndBootstrap();
